import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDataModel } from "../models/userDataModel";

export const userSlice = createSlice({
  name: "user",
  initialState: {} as UserDataModel,
  reducers: {
    loadUserData(state, action: PayloadAction<UserDataModel>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { loadUserData: loadUserData } = userSlice.actions;

export default userSlice.reducer;
